import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export { GetCantons, UpdateCantons, UpdateCities, GetCities, GetCitiesVNext, GetPaths, UpdatePaths };

function GetCantons(contractNumber, versionNumber, editionNumber, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionNumber}/canton`,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function UpdateCantons(contractNumber, versionNumber, editionNumber, cantons, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionNumber}/canton`,
      cantons,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function UpdateCities(contractNumber, versionNumber, editionNumber, cantons, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionNumber}/cities`,
      cantons,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function GetCities(contractNumber, versionNumber, editionNumber, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionNumber}/cities`,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function GetCitiesVNext(contractNumber, versionNumber, editionNumber, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionNumber}/cities/vnext`,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function GetPaths(contractNumber, versionNumber, editionNumber, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionNumber}/paths`,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function UpdatePaths(contractNumber, versionNumber, editionNumber, paths, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionNumber}/paths`,
      paths,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}
